import { Icon } from "@uigovpe/components";
import { useImageSource } from "@/hooks/images/useImageSource";

export type ProductPreviewData = {
  name?: string;
  description?: string;
  mainImageUrl?: string;
  keywords?: string[];
  category?: string;
  subcategory?: string;
  businessName?: string;
};

export function ProductPreviewCard({ data }: { data: ProductPreviewData }) {
  const { imageSource } = useImageSource(data.mainImageUrl);
  const keywords = data.keywords?.length
    ? data.keywords
    : ["Palavra-chave1", "Palavra-chave2"];
  return (
    <section className="w-full! overflow-hidden! rounded-lg! border! border-zinc-300! bg-zinc-50! shadow-sm!">
      <header className="flex! items-center! justify-center! gap-2! bg-[#4e3873]! px-4! py-3! text-sm! font-bold! text-white!">
        <Icon icon="visibility" outline /> Pré-visualização do Produto
      </header>
      <div className="p-5!">
        <p className="mb-4! text-xs! leading-5! text-zinc-700!">
          Veja como este produto poderá aparecer nos resultados de busca e no
          perfil do seu negócio.
        </p>
        <div className="overflow-hidden! rounded-md! bg-white! shadow-sm!">
          <div className="relative! flex! aspect-[16/9]! items-center! justify-center! overflow-hidden! bg-zinc-50!">
            <span className="absolute! top-3! left-3! z-10! rounded! border! border-zinc-300! bg-white! px-2! py-1! text-[10px]! text-zinc-700!">
              Prévia
            </span>
            {imageSource ? (
              <img
                src={imageSource}
                alt="Prévia do produto"
                className="h-full! w-full! object-cover!"
              />
            ) : (
              <div className="flex! flex-col! items-center! gap-2! text-zinc-600!">
                <span className="flex! size-9! items-center! justify-center! rounded-full! bg-zinc-200!">
                  <Icon icon="image" outline />
                </span>
                <span className="text-[10px]!">Sem imagem principal</span>
              </div>
            )}
          </div>
          <div className="p-4!">
            <p className="mb-3! text-[10px]! text-zinc-600!">
              {data.category || "Categoria"} <span className="px-1!">|</span>{" "}
              {data.subcategory || "Subcategoria"}
            </p>
            <h2 className="m-0! text-sm! font-bold! text-zinc-900!">
              {data.name || "Nome do Produto"}
            </h2>
            <p className="mt-1! text-xs! text-zinc-700!">
              {data.businessName || "Nome do negócio"}
            </p>
            <p className="mt-4! text-xs! leading-5! text-zinc-700! [overflow-wrap:anywhere]!">
              {data.description ||
                "Aqui fica a descrição do seu produto, com limite de até 120 caracteres."}
            </p>
            <div className="mt-4! flex! flex-wrap! gap-2!">
              {keywords.map((keyword) => (
                <span
                  key={keyword}
                  className="rounded-full! border! border-[#4e3873]! px-3! py-1! text-[10px]! text-[#4e3873]!"
                >
                  {keyword}
                </span>
              ))}
            </div>
            <div className="mt-5! flex! items-center! gap-2! text-[10px]! font-bold! text-[#4e3873]!">
              Visualizar detalhes do produto{" "}
              <Icon icon="arrow_right_alt" outline />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
